// extracted by mini-css-extract-plugin
export default {"app":"src_app__6LyV9","header":"src_header__3WJzN","body":"src_body__+EVSi","footer":"src_footer__y9nCj"};